export const PRODUCT_TYPE = {
    REGULAR: 'REGULAR',
    SUBSCRIPTION: 'SUBSCRIPTION',
    AFFILIATE: 'AFFILIATE',
}

export const HIDDEN_FIELD = {
    TARGET_AUDIENCE: 'targetAudience',
    KEYWORDS: 'keywords',
    VENDOR_ERP: 'vendorErp',
    VENDOR_MPN: 'vendorMpn',
    LOGISTICS: 'logistics',
    SECONDARY_IMAGES: 'secondaryImages',
    VIDEOS: 'videos',
    RENT_LOGISTICS: 'rentLogistics',
    RENT_RESTRICTED: 'rentRestricted',
    RECOMMENDATIONS: 'recommendations',
} as const;

export const PRODUCT_TYPE_HIDDEN_FIELDS: Record<string, ReadonlySet<string>> = {
    [PRODUCT_TYPE.SUBSCRIPTION]: Object.freeze(new Set([
        HIDDEN_FIELD.TARGET_AUDIENCE, HIDDEN_FIELD.KEYWORDS, HIDDEN_FIELD.VENDOR_ERP, HIDDEN_FIELD.VENDOR_MPN,
        HIDDEN_FIELD.LOGISTICS, HIDDEN_FIELD.SECONDARY_IMAGES, HIDDEN_FIELD.VIDEOS,
        HIDDEN_FIELD.RENT_LOGISTICS, HIDDEN_FIELD.RENT_RESTRICTED, HIDDEN_FIELD.RECOMMENDATIONS,
    ])),
    [PRODUCT_TYPE.AFFILIATE]: Object.freeze(new Set([
        HIDDEN_FIELD.TARGET_AUDIENCE, HIDDEN_FIELD.VENDOR_ERP, HIDDEN_FIELD.VENDOR_MPN,
        HIDDEN_FIELD.LOGISTICS, HIDDEN_FIELD.RENT_LOGISTICS, HIDDEN_FIELD.RENT_RESTRICTED,
        HIDDEN_FIELD.RECOMMENDATIONS,
    ])),
}

export const PRODUCT_CONSTANTS = {
    ALL_COUNTRIES: 'All countries',
    MOST_RECENT: 'Most recent',
    VENDOR: 'Vendor',
    PRODUCTS: 'products',
    REQUEST_SORT: 'requests-sort',
    REQUEST_SORT_BY_COUNTRY: 'requests-sort-country',
    PUBLISHED_PRODUCT_PATH: '/products/published',
    REQUEST_SORT_COUNTRY_ISO: 'requests-sort-country-iso',
    PRODUCT_IMAGE_VALIDATION_MESSAGE: 'Invalid file type. Please upload an image (JPEG, PNG).',
    PRODUCT_DOCS_VALIDATION_MESSAGE: 'Invalid file type. Please upload a file (PDF).',
    ERROR_FIELD : 'error-field',
    GO_LIVE: 'Go live',
    PUBLISH: 'Publish',
    NEW_PRODUCT: 'New product',
    NEW_PRODUCT_AI: 'New Product - AI Powered',
    NEW_SUBSCRIPTION: 'New subscription',
    NEW_AFFILIATE_PROGRAM: 'New Affiliate Program',
    DELETE_SELECTED: 'Delete selected',
    PUSH_SELECTED_ON_LIVE: 'Push selected published products onto live website.',
    SUBSCRIPTIONS: 'subscriptions',
}

export const PRODUCT_VALIDATION_STATUSES = [{id: 1, name: 'PENDING'}, {id: 2, name:'VALID'}, {id: 3, name:'INVALID'}];

export const MAX_DESCRIPTION_LENGTH = 5000;
export const WAREHOUSE_ERROR = 1;

export const MAX_PRODUCT_NAME_LENGTH = 100;

export const PRODUCT_STATUS = {
    PUBLISHED: 'published',
    DRAFT: 'draft',
    READY: 'ready',
    PUBLISHED_FAILED: 'publish_failed'
}

export const PRICE_TYPE = {
    PURCHASE: 'PURCHASE',
    RENT: 'RENT',
    SUBSCRIPTION: 'SUBSCRIPTION',
}

// Stable per-tab identity. The rendered tab list is filtered by product type (Smart Variants
// is dropped for SUBSCRIPTION/AFFILIATE, Affiliate form only appears for AFFILIATE), so tab
// positions shift between product types — identify tabs by key, never by index.
// These values intentionally match the route `view` segments, so a view maps straight to a tab.
export const TAB_KEYS = {
    DETAILS: 'details',
    WAREHOUSES: 'warehouses',
    VARIANTS: 'variants',
    SMART_VARIANTS: 'smart-variants',
    AFFILIATE_FORM: 'affiliate-form'
} as const;

export type TabKey = typeof TAB_KEYS[keyof typeof TAB_KEYS];

export const VALID_IMAGE_TYPES = ['image/jpeg', 'image/png']

export const VALID_DOCS_TYPES = [
    'application/pdf',
    'application/x-pdf',
    'application/x-bzpdf',
    'application/x-gzpdf'
];

export const VALIDATION_STATUS = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    PARTIAL: 'PARTIAL'
}

export const EDIT_ORDER_ACTIONS = {
    ADDED: 'ADDED',
    REMOVED: 'REMOVED',
    CHANGED: 'CHANGED',
    UNCHANGED: 'UNCHANGED'
}

export const EDIT_ORDER_RESULTS = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED'
}

export const PRODUCT_COLUMNS_STORAGE_KEY = 'productColumnsV2';